/* eslint-disable no-unused-vars */
/**
 * @file Controle da execução em jogo.
 * jsdoc Board.js ControlLevel.js  Construtor.js ControlGame.js -d ../../documention
 * @author William Luis Alves Ferreira (git:illiamw)
 * @version 2.0.0
 */
import React from "react";
import View_Rank from "./View_Rank";
import ModalFull from "./ViewComponentsNav/ModalFull";
import Modal from "./ViewComponentsNav/Modal";
import carregar from "../../Assets/carregar.gif";

//Logos
import logo from "./../../Assets/logo-eic-horizontal.svg";
import mais from "./../../Assets/Game-Button-PNG.webp";
import rank from "./../../Assets/rank-Button-PNG.webp";


import Auth from "../Controllers/Requests/ViewAuth";


//Componentes de roteamento
import { Link, Outlet, Navigate } from "react-router-dom";

/**
 * @param {Null} Null Null
 * @description Classe geradora da função app
 * @constructor
 */

export default class View_logar extends React.Component {
  constructor(props) {
    console.log("Abre tela logar");
    super(props)
    this.state = {
      testLogin: false,
      redirectLogin: false

    }
    // Vinculo entre que força atualização entre os filhos, este componente, e o props.Jogo

    this.update = this.update.bind(this);

    this.props.auth.ancora(this.update);

  }

  componentDidMount() {
    this.props.auth.init()

  }


  update(isLogin) {
    this.setState({
      testLogin: true
    });
    if (isLogin) {
      this.setState({
        redirectLogin: true
      });
    }
    else
      this.setState({
        redirectLogin: false
      });
  }


  render() {
    if (!this.state.testLogin) {
      return (
        <div className="d-flex flex-row justify-content-center align-items-center h-100 w-100">
          <div className="flex-fill">
            <img
              className="img-fluid img-loading"
              src={carregar}
              alt="nevegue clicando nas palavras do tabuleiro"
            />
          </div>
        </div >
      );
    } else {
      if (!this.state.redirectLogin)
        // ROTEAMENTO - colocar controle de estados da aplicação
        return (


          <div id="TESTE" className="col d-flex flex-column align-items-center bg-color1 text-center w-100 h-100 ">

            <div className="flex-fill bg-color1 w-100 text-center align-items-start d-flex justify-content-between">
              <div className="d-flex col justify-content-start">
                <a className="mais-jogos" href="https://eic.ifsc.usp.br/category/jogos/">
                  <img
                    src={mais}
                    alt="Mais jogos"
                    href="https://eic.ifsc.usp.br/category/jogos/"
                    className="img-fluid w-logo"
                  />
                </a>

              </div>
              <div className="d-flex col  justify-content-end">
                <div data-bs-toggle="modal" className="mais-jogos"
                  data-bs-target="#modal-rank">
                  <img
                    src={rank}
                    alt="Mais jogos"
                    href="https://eic.ifsc.usp.br/category/jogos/"
                    className="img-fluid w-logo"
                  />
                </div>
              </div>
            </div>
            <div className="flex-grow-1 p-3 d-flex align-items-center">

              <div className="col">
                <a href="http://eic.ifsc.usp.br/">
                  <img
                    src={logo}
                    alt="Logo"
                    href="http://eic.ifsc.usp.br/"
                    className="img-fluid w-logo"
                  />
                </a>
              </div>
            </div>

            <div className="flex-fill bg-color1  p-3 text-center align-items-center">
              <div>
                <h1 className="text-white1 display-1 fw-bold">Cruzadinhas </h1>
                <h2 className="text-color4 display-4 fw-bold">Jardim Medicinal</h2>
              </div>
            </div>

            <div className="flex-shrink-1 bg-color1  p-3 text-center align-items-end">
              <div>
                <button
                  type="button"
                  className="button-custom inicial bg-color4 arround-6"
                  data-bs-toggle="modal"
                  data-bs-target="#modal-login"
                >
                  ENTRAR
                </button>
              </div>
            </div>

            <div className="flex-shrink-1 w-100 bg-color1  px-3 text-center  d-flex justify-content-between align-items-end">
              <div>
                <Link to="/creditos">
                  <i className="material-icons md-light md-48">groups</i>
                </Link>
              </div>
              <div>
                <Link to="/compartilhar">
                  <i className="material-icons md-light md-48">share</i>
                </Link>
              </div>
              <Outlet />

            </div>

            <ModalFull vinculo="modal-rank">
              <div className="view1">
                <View_Rank className="flex-fill" serve={this.props.serve} auth={this.props.auth} />
              </div>
            </ModalFull>

            <Modal vinculo="modal-login" titulo="Entrar">
              <Auth auth={this.props.auth}></Auth>

            </Modal>
          </div>



        );

      else
        return (<Navigate to="/" />);
    }
  }
}
